import { apiUpdateUserDetails } from '../../helpers/api';
import { objectRemoveUndefined, objectToFormData } from '../../helpers/jsHelper';
import { dispatcher } from '../../helpers/projectHelper';
import { isCuratorPage } from '../../helpers/urlHelper';
import { gamificationTooltipActions } from '../../redux/slicers/gamificationTooltipSlicer';

export const isUserOnboarding = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isOnboarding = urlParams.get('isOnboarding') || false;
  return (isOnboarding === true || isOnboarding === 'true') && isCuratorPage();
};

export const setTooltipData = (obj) => {
  const objToSet = {};
  if ('step' in obj) {
    objToSet.step = obj.step;
  }
  if ('coordinates' in obj) {
    objToSet.coordinates = obj.coordinates;
  }
  if ('target' in obj) {
    objToSet.target = obj.target;
  }
  if ('placement' in obj) {
    objToSet.placement = obj.placement;
  }
  if ('showArrow' in obj) {
    objToSet.showArrow = obj.showArrow;
  }
  const _objToSet = objectRemoveUndefined(objToSet);
  if (Object.keys(_objToSet).length > 0) {
    dispatcher(gamificationTooltipActions.setData(_objToSet));
  }
};

export const blurGrid = () => {
  document.body.classList.add('overlayGrid');
};

export const addBlurToAll = () => {
  document.body.classList.add('overlayCuratorHeader');
  document.body.classList.add('overlayCuratorSidebar');
  document.body.classList.add('overlayCuratorContainer');
};

export const resetBlurAll = () => {
  document.body.classList.remove('overlayCuratorHeader');
  document.body.classList.remove('overlayCuratorSidebar');
  document.body.classList.remove('overlayCuratorContainer');
  document.body.classList.remove('overlayGrid');
};

export const showHideTooltip = async (currentUser, updateUserData, obj) => {
  const { user } = currentUser;
  const { other_info } = user;
  const data = {
    ...other_info,
    ...obj,
  };
  const payload = {
    other_info: JSON.stringify(data),
  };
  const formData = objectToFormData(payload);
  const res = await apiUpdateUserDetails(formData);
  if (res && updateUserData) {
    updateUserData({
      ...currentUser,
      user: {
        ...currentUser?.user,
        other_info: {
          ...currentUser?.user?.other_info,
          ...res?.other_info,
        },
      },
    });
  }
};

export const isUserOnboardingNonCurator = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const isOnboarding = urlParams.get('isOnboarding') || false;
  return (isOnboarding === true || isOnboarding === 'true') && !isCuratorPage();
};
